<template>
  <v-app>
    <v-toolbar color="indigo" dark app fixed>
      <v-toolbar-side-icon @click="$router.push('/')">
        <v-icon>home</v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title class="font-weight-light" @click="$router.push('/')">String Tools</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
export default {
  data: () => ({
    drawer: false
  })
}
</script>
